window.GodTurConfig = {
  adaptiveUrl: 'https://telltura3.avinet.no/',
  guiUrl: 'https://godtur.avinet.no',
  appName: 'GodTur',
  gm_lang_code: 'nb',
  mapProjCode: '3857'
};



// WEBPACK FOOTER //
// ./src/config/Swipe.js